import { Select } from '@fluentui/react-components';
import type { ThemeMode } from '../hooks/useTheme';

interface ThemeToggleProps {
  mode: ThemeMode;
  onChange: (mode: ThemeMode) => void;
}

export default function ThemeToggle({ mode, onChange }: ThemeToggleProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <span style={{ fontSize: '0.75rem', color: 'var(--colorNeutralForeground3)' }}>Theme:</span>
      <Select
        size="small"
        value={mode}
        onChange={(_, d) => onChange(d.value as ThemeMode)}
        style={{ minWidth: 80 }}
      >
        <option value="dark">Dark</option>
        <option value="light">Light</option>
        <option value="system">System</option>
      </Select>
    </div>
  );
}
